import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../assets/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: '7px 36px',
    },
    switchWrapper: {
      padding: 18,
      borderBottom: `2px solid ${Colors.Gray5}`,
      '& > *': {
        display: 'inline-flex',
        verticalAlign: 'top',
      },
    },
    lastItem: {
      borderBottom: 0,
    },
  };
});

export default useStyles;